<template>
  <div v-if="dataReady">
    <div class="full-width">
          <p class="card-title">
            {{ getString("module.dashboard.stats.accounts") }}
          </p>
          <div class="card-block scroll">
            <div class="row">
              <div class="col">
                <b>{{ getString("module.dashboard.stats.resource") }}</b>
                <h5 class="q-mt-md q-mb-sm">
                  {{ data.resource }}
                </h5>
              </div>
              <div class="col">
                <b>{{ getString("module.dashboard.stats.contact.base") }}</b>
                <h5 class="q-mt-md q-mb-sm">
                  {{ data.contact }}
                </h5>
              </div>
            </div>
          </div>
        </div>
  </div>
</template>

<script>
import statistics from './statisticsComponent';

export default {
  mixins: [statistics],
  data() {
    return {
      component: 'accounts',
    };
  },
};
</script>

<style lang="stylus" scoped src="@/styles/components/statistics.styl"></style>
